module.exports = __webpack_public_path__ + "static/img/1.39bcbd1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/zh/1.png
// module id = QOFg
// module chunks = 0